import styled from 'styled-components';

const LoadingDotsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
`;
const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme.palette.iron};
  border-radius: 50%;
  animation: colorChange 1.3s infinite;

  @keyframes colorChange {
    0% {
      background-color: ${({ theme }) => theme.palette.iron};
    }
    25% {
      background-color: ${({ theme }) => theme.palette.R600};
    }
    100% {
      background-color: ${({ theme }) => theme.palette.iron};
    }
  }

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.4s;
  }

  &:nth-child(3) {
    animation-delay: 0.8s;
  }

  &:nth-child(4) {
    animation-delay: 1.2s;
  }
`;
function LoadingDots() {
  return (
    <LoadingDotsContainer>
      <Dot />
      <Dot />
      <Dot />
      <Dot />
    </LoadingDotsContainer>
  );
}

export default LoadingDots;
